import MiForm from './MiForm.vue'

export default MiForm
